<template>
  <v-app>
    <v-container>
      <v-layout row wrap>
        <v-flex lg12 md12 sm12 xs12>
          <div class="mb-3 mt-3">
            <h2>Informe de ventas</h2>
          </div>
          <div>
            <span
              ><router-link
                class="links-informe-ventas"
                :to="{ path: '/mis-eventos' }"
                title="Ver todos mis eventos"
                >Volver a Mis Eventos</router-link
              ></span
            ><span> > </span><span>Informe de ventas</span>
          </div>
          <div class="mt-3 mb-4"></div>
        </v-flex>
      </v-layout>
      <v-divider></v-divider>
      <v-layout row wrap>
        <v-flex lg6 md6 sm6 xs12 mb-3>
          <v-dialog
            ref="dialogDesde"
            v-model="modalDesde"
            :return-value.sync="desde"
            width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="desde"
                label="Desde *"
                prepend-icon="event"
                readonly
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="desde"
              scrollable
              locale="es-ES"
              :max="hoy"
              :min="primer_fecha_venta"
            >
              <v-spacer></v-spacer>
              <v-btn flat color="primary" @click="modalDesde = false"
                >Cancelar</v-btn
              >
              <v-btn flat color="primary" @click="$refs.dialogDesde.save(desde)"
                >OK</v-btn
              >
            </v-date-picker>
          </v-dialog>
        </v-flex>
        <v-flex lg6 md6 sm6 xs12 mb-3>
          <v-dialog
            ref="dialogHasta"
            v-model="modalHasta"
            :return-value.sync="hasta"
            width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="hasta"
                label="Hasta *"
                prepend-icon="event"
                readonly
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="hasta"
              scrollable
              locale="es-ES"
              :max="hoy"
              :min="primer_fecha_venta"
            >
              <v-spacer></v-spacer>
              <v-btn flat color="primary" @click="modalHasta = false"
                >Cancelar</v-btn
              >
              <v-btn flat color="primary" @click="$refs.dialogHasta.save(hasta)"
                >OK</v-btn
              >
            </v-date-picker>
          </v-dialog>
        </v-flex>
        <v-flex lg6 md6 sm6 xs12 mb-3>
          <v-select
            v-model="evento_filter"
            item-value="id"
            item-text="nombre"
            :items="eventos"
            label="Seleccionar un evento *"
            prepend-icon="pageview"
            required
            @change="searchPuntosVenta"
          ></v-select>
        </v-flex>
        <v-flex lg6 md6 sm6 xs12 mb-3>
          <v-select
            v-model="punto_venta"
            item-value="punto_ventum.id"
            item-text="punto_ventum.email"
            :items="puntosventa_evento"
            label="Seleccionar un punto de venta"
            prepend-icon="store_mall_directory"
            required
            no-data-text="No hay resultados..."
          ></v-select>
        </v-flex>
      </v-layout>
      <div class="text-right">
        <v-btn color="info" @click="searchInformeVentas"
          ><v-icon>search</v-icon> BUSCAR</v-btn
        >
      </div>
      <v-layout row wrap v-if="show_button_cierre_diario">
        <v-flex lg4 md4 sm6 xs12 mb-3>
          <v-btn
            @click="modalCierreDiario = true"
            color="info"
            title="Ver el cierre diario"
            ><v-icon>history</v-icon> VER CIERRE DIARIO</v-btn
          >
        </v-flex>
        <v-flex lg4 md4 sm6 xs12>
          <export-excel
            style="width: fit-content"
            :data="exportVentas"
            :export-fields="json_fields"
            worksheet="Cierre diario"
            :name="desde + '/' + hasta + '.xls'"
            ><v-btn color="success"
              ><v-icon left>cloud_download</v-icon> EXPORT A EXCEL</v-btn
            ></export-excel
          >
        </v-flex>
      </v-layout>
      <v-divider></v-divider>
      <v-data-table
        :headers="headers"
        must-sort
        :items="facturas"
        hide-default-footer
        :itemsPerPage="facturas.length"
        :length="pages"
        :search="search"
        class="elevation-1 table-ventas"
        :loading="loading"
        :no-data-text="'No se han encontrado ventas...'"
      >
        <template v-slot:items="props">
          <td class="font-weight-bold">#{{ props.item.id }}</td>
          <td class="text-xs-center">
            {{ formatFechaHumans(props.item.fecha) }}<br /><small>{{
              props.item.fecha
            }}</small>
          </td>
          <td class="text-xs-center">
            {{ props.item.punto_ventum.nombre_razon }}
          </td>
          <td class="text-xs-center">{{ props.item.cliente }}</td>
          <td class="text-xs-center">{{ props.item.pago_parcial }}</td>
          <td class="text-xs-center text-uppercase">
            {{ props.item.forma_pago }}
          </td>
          <td class="text-xs-center text-uppercase">
            {{ props.item.code_voucher }}
          </td>
        </template>
        <template v-slot:item.venta_total="{ item }">
          <td class="slot-td-tabla-info-ventas">
            {{ item.moneda.simbolo
            }}{{ formatoMoneda(getTotalVenta(item.detalle_vents, 0)) }} ({{
              item.moneda.codigo_moneda
            }})
          </td>
        </template>
        <template v-slot:item.pagos_total="{ item }">
          <td class="slot-td-tabla-info-ventas">
            {{ item.moneda.simbolo
            }}{{ formatoMoneda(getTotalAbonado(item.id)) }} ({{
              item.moneda.codigo_moneda
            }})
          </td>
        </template>
        <template v-slot:item.actions="{ item }">
          <td class="slot-td-tabla-info-ventas">
            <v-icon
              title="Visualizar la factura"
              class="btn-action-info-ventas"
              @click="searchFactura(item.id)"
            >
              receipt
            </v-icon>
          </td>
        </template>
      </v-data-table>
      <div class="text-xs-center pt-2">
        <v-pagination v-model="pagination.page" :length="pages"></v-pagination>
      </div>
      <h2 v-if="facturasCierreDiario.length > 0" class="text-right">
        <v-icon large>attach_money</v-icon> TOTAL:<b>
          {{ facturasCierreDiario[0].moneda.simbolo
          }}{{ formatNumber(totalVentasCierreDiario.total) }}</b
        >
        ({{ facturasCierreDiario[0].codigo_moneda }})
      </h2>
      <v-dialog
        v-if="modalCierreDiario"
        v-model="modalCierreDiario"
        max-width="500px"
        persistent
      >
        <v-card>
          <div id="printFactura">
            <v-card-title>
              <div class="text-center col-md-12 col-lg-12 col-sm-12 col-xs-12">
                <img
                  src="/images/logo-ticketshop.png"
                  style="max-width: 150px; width: 150px"
                />
              </div>
            </v-card-title>
            <v-container>
              <v-card-text>
                <h6 class="text-center"><b>CIERRE DIARIO</b></h6>
                <h6 class="text-center">
                  <b>{{ desde }} - {{ hasta }}</b>
                </h6>
                <h6 class="text-center">
                  <b>{{
                    eventos.filter((item) => item.id == evento_filter)[0].nombre
                  }}</b>
                </h6>
                <h6 class="text-center">
                  <b>{{
                    puntosventa_evento.filter(
                      (item) => item.punto_ventum.id == punto_venta
                    )[0].punto_ventum.nombre_razon
                  }}</b>
                </h6>
                <br />
                <table class="table">
                  <thead>
                    <tr>
                      <th class="text-center">N° FACTURA</th>
                      <th class="text-center">TIPO PAGO</th>
                      <th class="text-center">FECHA</th>
                      <th class="text-center">TOTAL</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      :key="index"
                      v-for="(item, index) in facturasCierreDiario"
                    >
                      <td class="text-center font-weight-bold">
                        # {{ item.id }}
                      </td>
                      <td class="text-center">{{ item.pago_parcial }}</td>
                      <td class="text-center">{{ item.fecha }}</td>
                      <td class="text-center">
                        {{ item.moneda.simbolo
                        }}{{ formatNumber(item.total) }} ({{
                          item.codigo_moneda
                        }})
                      </td>
                    </tr>
                  </tbody>
                </table>
                <br />
                <br />
                <hr />
                <div class="text-right">
                  <h5>
                    TOTAL EFECTIVO:<b>
                      {{ facturasCierreDiario[0].moneda.simbolo
                      }}{{
                        formatNumber(totalVentasCierreDiario.total_efectivo)
                      }}</b
                    >
                    ({{ facturasCierreDiario[0].codigo_moneda }})
                  </h5>
                  <h5>
                    TOTAL TARJETA:<b>
                      {{ facturasCierreDiario[0].moneda.simbolo
                      }}{{
                        formatNumber(totalVentasCierreDiario.total_tarjeta)
                      }}</b
                    >
                    ({{ facturasCierreDiario[0].codigo_moneda }})
                  </h5>
                  <h5>
                    TOTAL TARJETA DEBITO:<b>
                      {{ facturasCierreDiario[0].moneda.simbolo
                      }}{{
                        formatNumber(totalVentasCierreDiario.total_debito)
                      }}</b
                    >
                    ({{ facturasCierreDiario[0].codigo_moneda }})
                  </h5>
                  <h5>
                    TOTAL TARJETA CREDITO:<b>
                      {{ facturasCierreDiario[0].moneda.simbolo
                      }}{{
                        formatNumber(totalVentasCierreDiario.total_credito)
                      }}</b
                    >
                    ({{ facturasCierreDiario[0].codigo_moneda }})
                  </h5>
                  <hr />
                  <h4>
                    TOTAL:<b>
                      {{ facturasCierreDiario[0].moneda.simbolo
                      }}{{ formatNumber(totalVentasCierreDiario.total) }}</b
                    >
                    ({{ facturasCierreDiario[0].codigo_moneda }})
                  </h4>
                </div>
              </v-card-text>
            </v-container>
          </div>
          <hr />
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="success" @click="printFactura">IMPRIMIR</v-btn>
            <v-btn color="blue darken-1" flat @click="modalCierreDiario = false"
              >Cerrar</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </v-app>
</template>
<script>
import moment from "moment";
moment.locale("es");

export default {
  data() {
    return {
      search: "",
      desde: null,
      hasta: null,
      modalDesde: false,
      modalHasta: false,
      evento_filter: null,
      show_list_eventos: false,
      show_list_puntosventa: false,
      show_button_cierre_diario: false,
      modalCierreDiario: false,
      punto_venta: null,
      puntosventa_evento: [],
      headers: [
        {
          text: "N° VENTA",
          align: "left",
          sortable: false,
          value: "id",
        },
        { text: "FECHA", value: "fecha", align: "center", sortable: false },
        {
          text: "PUNTO VENTA",
          value: "punto_ventum.nombre_razon",
          align: "center",
          sortable: false,
        },
        { text: "CLIENTE", value: "cliente", align: "center", sortable: false },
        {
          text: "TIPO DE PAGO",
          value: "pago_parcial",
          align: "center",
          sortable: false,
        },
        {
          text: "OBSERVACIÓN",
          value: "observacion",
          align: "center",
          sortable: false,
        },
        {
          text: "FORMA DE PAGO",
          value: "forma_pago",
          align: "center",
          sortable: false,
        },
        {
          text: "COD VOUCHER",
          value: "code_voucher",
          align: "center",
          sortable: false,
        },
        {
          text: "TOTAL VENTA",
          value: "venta_total",
          align: "center",
          sortable: false,
        },
        {
          text: "TOTAL PAGADO",
          value: "pagos_total",
          align: "center",
          sortable: false,
        },
        { text: "ACCIONES", value: "actions", sortable: false },
      ],
      json_fields: {
        "N° VENTA": "id",
        FECHA: "fecha",
        "PUNTO VENTA": "punto_ventum.nombre_razon",
        CLIENTE: "cliente",
        "TIPO DE PAGO": "pago_parcial",
        "FORMA DE PAGO": "forma_pago",
        "COD VOUCHER": "code_voucher",
        "TOTAL PAGADO": "total",
      },
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8",
          },
        ],
      ],
    };
  },
  async beforeCreate() {
    document.title = "Informe de ventas - TicketShop";
    await this.$store.dispatch("evento/listMisEventos");
    if (
      this.$route.params.evento != null ||
      this.$route.params.evento != undefined
    ) {
      this.evento_filter = this.$route.params.evento;
    } else {
      this.evento_filter = null;
    }

    await this.$store.dispatch("carrito/informeVentasJefePuntoVenta", {
      page: 1,
      desde: null,
      hasta: null,
      id_evento: this.evento_filter,
      punto_venta: null,
    });
    if (
      this.$route.params.evento != null ||
      this.$route.params.evento != undefined
    ) {
      this.puntosventa_evento = this.eventos.filter(
        (item) => item.id == this.evento_filter
      )[0].puntoventa_eventos;
    }
  },
  watch: {
    pagination: {
      async handler() {
        this.$store.dispatch("carrito/informeVentasJefePuntoVenta", {
          page: this.pagination.page,
          desde: this.desde,
          hasta: this.hasta,
          id_evento: this.evento_filter,
          punto_venta: this.punto_venta,
        });
      },
      deep: true,
    },
  },
  computed: {
    usuario() {
      return this.$store.getters["user/dataUserLogged"];
    },
    facturas() {
      return this.$store.getters["carrito/facturas"];
    },
    factura() {
      return this.$store.getters["carrito/factura"];
    },
    pagination() {
      return this.$store.getters["carrito/paginationFacturas"];
    },
    pages() {
      return this.$store.getters["carrito/pagesFacturas"];
    },
    totalItemCount() {
      return this.$store.getters["carrito/totalItemCount"];
    },
    loading() {
      return this.$store.getters["carrito/loading"];
    },
    eventos() {
      return this.$store.getters["evento/listEventos"];
    },
    facturasCierreDiario() {
      return this.$store.getters["carrito/facturasCierreDiario"];
    },
    totalVentasCierreDiario() {
      return this.$store.getters["carrito/totalVentasCierreDiario"];
    },
    puntosventa() {
      return this.$store.getters["puntoventa/listPuntoventas"];
    },
    exportVentas() {
      return this.$store.getters["carrito/exportVentas"];
    },
    hoy() {
      return moment().format("YYYY-MM-DD");
    },
    primer_fecha_venta() {
      return moment(
        this.$store.getters["carrito/primer_fecha_venta_pdv"]
      ).format("YYYY-MM-DD");
    },
  },
  methods: {
    formatNumber(number) {
      return new Intl.NumberFormat("es-CO", {
        minimumFractionDigits: 0,
      }).format(number);
    },
    printFactura() {
      // Pass the element id here
      this.$htmlToPaper("printFactura");
    },
    formatoMoneda(valor) {
      if (valor != null && valor != "") {
        return new Intl.NumberFormat("es-CO").format(valor);
      } else {
        return "";
      }
    },
    formatFechaHumans(fecha) {
      return moment(fecha).fromNow();
    },
    searchInformeVentas() {
      if (
        this.desde != null &&
        this.hasta != null &&
        this.evento_filter != null
      ) {
        this.$store.dispatch("carrito/informeVentasJefePuntoVenta", {
          page: 1,
          desde: this.desde,
          hasta: this.hasta,
          id_evento: this.evento_filter,
          punto_venta: this.punto_venta,
        });
        if (this.punto_venta != null) {
          this.show_button_cierre_diario = true;
        }
      } else {
        swal(
          "Error!",
          "Completa los campos para realizar la busqueda!",
          "error"
        );
      }
    },
    searchFactura(id) {
      this.$store.dispatch("carrito/searchFactura", id);
    },
    searchPuntosVenta() {
      this.puntosventa_evento = this.eventos.filter(
        (item) => item.id == this.evento_filter
      )[0].puntoventa_eventos;
    },
    getTotalVenta(detalle_vents, abonado) {
      var totalVenta = 0;
      for (var i = 0; i < detalle_vents.length; i++) {
        totalVenta +=
          detalle_vents[i].precio_servicio +
          detalle_vents[i].precio_venta +
          (detalle_vents[i].precio_servicio + detalle_vents[i].precio_venta) *
            detalle_vents[i].impuesto;
      }
      return totalVenta - abonado;
    },
    getTotalAbonado(id) {
      var abonos = this.facturas.filter((item) => item.id == id)[0];
      var totalAbonado = abonos.total;

      for (var i = 0; i < abonos.abonos_venta_parcial.length; i++) {
        totalAbonado +=
          abonos.abonos_venta_parcial[i].monto_efectivo +
          abonos.abonos_venta_parcial[i].monto_tarjeta;
      }
      return totalAbonado;
    },
  },
};
</script>
<style scoped>
.elevation-1.table-ventas table thead {
  background-color: #cacaca;
}
.elevation-1.table-ventas table thead th {
  color: black;
  font-weight: bold;
}
.elevation-1.table-ventas table tbody td {
  color: black;
  font-size: 16px;
}
.links-informe-ventas {
  color: #1976d2 !important;
  text-decoration: underline;
}
.links-informe-ventas:hover {
  text-decoration: underline !important;
}
.slot-td-tabla-info-ventas {
  font-size: 14px !important;
  text-align: center;
}
</style>